import { FiltersMap } from '@wix/bex-core';
import { useEffect, useState } from 'react';
import { CollectionTableProps } from './CollectionTable';
import { useToolbarCollectionSyncProps } from '../ToolbarCollection/useToolbarCollectionSyncProps';
import { assertComponentType } from '../assertComponentType';
import { SelectionDisabledProp } from '../../state/BulkActionToolbarState';
import { useColumnsSyncProps } from '../../hooks/useColumnsSyncProps';

export function useTableCollectionSyncProps<T, F extends FiltersMap>(
  props: CollectionTableProps<T, F> & {
    isUsingTableVirtualization: boolean;
  },
) {
  const {
    state: table,
    customColumns,
    columns: tableColumns,
    showSelection,
    actionsCell,
    multiLevelSorting,
    views,
    selectionDisabled,
    dataExtension,
    isUsingTableVirtualization,
    dragAndDropReorderModeToolbar,
  } = props;

  assertComponentType(customColumns, 'CustomColumns', 'customColumns');
  assertComponentType(
    multiLevelSorting,
    'MultiLevelSorting',
    'multiLevelSorting',
  );
  assertComponentType(views, 'CollectionViewsDropdown', 'views');
  assertComponentType(
    dragAndDropReorderModeToolbar,
    'ReorderModeToolbar',
    'dragAndDropReorderModeToolbar',
  );

  const state = table.toolbar;

  useToolbarCollectionSyncProps({
    ...props,
    state,
    isUsingDragAndDrop: !!props.dragAndDrop,
    isUsingBulkActionsToolbar: !!props.bulkActionToolbar,
    isUsingHorizontalScroll: props.horizontalScroll ?? false,
    isUsingFolders: false,
    isUsingTableVirtualization,
  });

  useColumnsSyncProps({
    toolbar: state,
    customColumns,
    columns: tableColumns,
  });

  useState(() => dataExtension?.setDataExtensionOnTable(state));

  useEffect(() => {
    if (!dragAndDropReorderModeToolbar) {
      return;
    }
    dragAndDropReorderModeToolbar?.type.setReorderModeState(state);
  }, [state._dnd, dragAndDropReorderModeToolbar]);

  useEffect(() => state.selectionProps.set({ showSelection }), [showSelection]);
  useEffect(() => state.actionsCell.set(actionsCell), [actionsCell]);

  if (selectionDisabled != null) {
    state.bulk.selectionDisabledProp =
      selectionDisabled as SelectionDisabledProp;
  }

  return state;
}
